export default __webpack_public_path__ + "static/media/sg2.4c217b95.png";